// Connect 4 Battle Server Engine (7 columns x 6 rows)
export class Connect4Engine {
  constructor(io, room) {
    this.io = io;
    this.room = room;
    this.board = Array(6).fill(null).map(() => Array(7).fill(0));
    this.player1 = null; // Red (1)
    this.player2 = null; // Yellow (2)
    this.currentTurn = 1;
    this.winner = null;
  }

  start() {
    this.board = Array(6).fill(null).map(() => Array(7).fill(0));
    this.player1 = this.room.players[0] || null;
    this.player2 = this.room.players[1] || null;

    if (!this.player2 && this.room.settings?.fillBots !== false) {
      this.player2 = { id: 'bot_c4', name: '🤖 FourBot', isBot: true };
    }

    this.currentTurn = 1;
    this.winner = null;

    this.io.to(this.room.code).emit('c4_started', {
      player1: this.player1,
      player2: this.player2,
      currentTurn: this.currentTurn,
      board: this.board
    });
  }

  checkBotTurn() {
    if (this.winner || this.currentTurn !== 2 || !this.player2?.isBot) return;

    setTimeout(() => {
      if (this.winner || this.currentTurn !== 2) return;
      const validCols = [];
      for (let c = 0; c < 7; c++) {
        if (this.board[0][c] === 0) validCols.push(c);
      }
      if (validCols.length === 0) return;

      // Heuristic: win if possible, otherwise pick valid column
      let chosenCol = validCols[Math.floor(Math.random() * validCols.length)];
      for (const c of validCols) {
        let r = -1;
        for (let row = 5; row >= 0; row--) {
          if (this.board[row][c] === 0) { r = row; break; }
        }
        if (r !== -1 && this.checkWin(r, c, 2)) {
          chosenCol = c;
          break;
        }
      }
      this.dropPiece(this.player2.id, chosenCol);
    }, 700);
  }

  dropPiece(playerId, column) {
    if (this.winner) return;
    const isP1 = this.player1 && this.player1.id === playerId;
    const isP2 = this.player2 && this.player2.id === playerId;

    if ((this.currentTurn === 1 && !isP1) || (this.currentTurn === 2 && !isP2)) {
      return; // Not your turn
    }

    if (column < 0 || column > 6) return;

    // Find lowest available row in column
    let targetRow = -1;
    for (let r = 5; r >= 0; r--) {
      if (this.board[r][column] === 0) {
        targetRow = r;
        break;
      }
    }

    if (targetRow === -1) return; // Column full

    const piece = this.currentTurn;
    this.board[targetRow][column] = piece;

    const winningLine = this.checkWin(targetRow, column, piece);

    this.io.to(this.room.code).emit('c4_pieceDropped', {
      row: targetRow,
      column,
      piece,
      currentTurn: this.currentTurn === 1 ? 2 : 1,
      board: this.board,
      winningLine
    });

    if (winningLine) {
      this.winner = piece === 1 ? this.player1 : this.player2;
      this.io.to(this.room.code).emit('c4_gameOver', { winner: this.winner, winningLine });
    } else if (this.isBoardFull()) {
      this.io.to(this.room.code).emit('c4_gameOver', { winner: null, isDraw: true });
    } else {
      this.currentTurn = this.currentTurn === 1 ? 2 : 1;
      this.checkBotTurn();
    }
  }

  checkWin(r, c, p) {
    const directions = [
      [[0, 1], [0, -1]], // Horizontal
      [[1, 0], [-1, 0]], // Vertical
      [[1, 1], [-1, -1]], // Diagonal \
      [[1, -1], [-1, 1]]  // Diagonal /
    ];

    for (const [[dr1, dc1], [dr2, dc2]] of directions) {
      let count = 1;
      const line = [{ r, c }];

      for (let step = 1; step < 4; step++) {
        const nr = r + dr1 * step;
        const nc = c + dc1 * step;
        if (nr >= 0 && nr < 6 && nc >= 0 && nc < 7 && this.board[nr][nc] === p) {
          count++;
          line.push({ r: nr, c: nc });
        } else break;
      }

      for (let step = 1; step < 4; step++) {
        const nr = r + dr2 * step;
        const nc = c + dc2 * step;
        if (nr >= 0 && nr < 6 && nc >= 0 && nc < 7 && this.board[nr][nc] === p) {
          count++;
          line.push({ r: nr, c: nc });
        } else break;
      }

      if (count >= 4) return line;
    }
    return null;
  }

  isBoardFull() {
    return this.board[0].every((cell) => cell !== 0);
  }

  destroy() {}
}
